import React, { Component } from 'react';
import KYCContainer from '../KYCContainer/KYC';
import Selfie from '../../../components/Slfie/Selfie';
import { UserKycStatus } from '../../../common/userData/UserKycStatus';

class SelfieContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pan: '',
      address: '',
      selfie: '',
      bank: '',
      custom: '',
      ref: ''
    };
  }
  onclick_handler = id => {
    if (id == 'selfie') {
      document.getElementById('selfie_mobile_01234').click();
    }
  };
  componentDidMount() {
    console.log(document.getElementById('selfie_mobile_01234'));
    document
      .getElementById('selfie_mobile_01234')
      .addEventListener('change', function() {
        document.getElementById('mobile_doc_list').style.display = 'none';
        document.getElementById('selfie_main_container').style.display =
          'block';
      });
  }

  current_page = {
    pan: false,
    address: false,
    selfie: true,
    bank: false,
    ref: false
  };
  render() {
    // const userstatus = UserKycStatus().then(res => {
    //   this.setState({
    //     pan: res.pan,
    //     address: res.aadhar,
    //     selfie: res.selfie,
    //     bank: res.bank,
    //     ref: res.ref,
    //     custom: false
    //   });
    // });

    return (
      <>
        <KYCContainer
          guideName="Selfie"
          data={this.state}
          curr_page={this.current_page}
          container={Selfie}
          // onclick_handler={this.onclick_handler}
          // componentHandler={this.props.componentHandler}
        />
      </>
    );
  }
}
export default SelfieContainer;
